module.exports = __webpack_public_path__ + "86d7760a1783b3af54765cbad23df209.svg";